module.exports = __webpack_public_path__ + "static/media/seller-panel.9e7f542f.svg";